export default class Captcha {
    private static inited: boolean = false;

    public static async init(sitekey: string) {
        return new Promise(async (res, err) => {
            if (this.inited) {
                res(true);
                return;
            }

            await $.getScript('https://www.google.com/recaptcha/api.js?render=' + sitekey);

            const timer = setInterval(() => {
                if ((<any>window).grecaptcha) {
                    clearInterval(timer);

                    (<any>window).grecaptcha.ready(() => {
                        this.inited = true;
                        res(true);
                    });
                }
            }, 300);
        });
    }

    public static async submit(sitekey: string): Promise<string> {
        return new Promise((res, err) => {
            if (!this.inited) {
                throw 'Błąd ReCaptcha';
            }

            (<any>window).grecaptcha.execute(sitekey, { action: 'submit' }).then((token) => {
                res(token);
            });
        });
    }
}
